import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ProjectFilterContextType {
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  triggerSearch: () => void;
  searchTrigger: number;
}

const ProjectFilterContext = createContext<ProjectFilterContextType | undefined>(undefined);

export const ProjectFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [statusFilter, setStatusFilter] = useState<string>('');
  const [searchTrigger, setSearchTrigger] = useState<number>(0);

  const triggerSearch = () => {
    setSearchTrigger(prev => prev + 1);
  };

  return (
    <ProjectFilterContext.Provider value={{ statusFilter, setStatusFilter, triggerSearch, searchTrigger }}>
      {children}
    </ProjectFilterContext.Provider>
  );
};

export const useProjectFilter = () => {
  const context = useContext(ProjectFilterContext);
  if (context === undefined) {
    // Return default values if not in provider (for non-client users)
    return {
      statusFilter: '',
      setStatusFilter: () => {},
      triggerSearch: () => {},
      searchTrigger: 0
    };
  }
  return context;
};